/** Dil listesi ve düşme zinciri — katalog içermez (vitrinin istemci paketi de kullanır; F7-17). */
export const SUPPORTED_LOCALES = ['tr', 'en', 'de', 'ar'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'tr';
export const RTL_LOCALES: ReadonlySet<Locale> = new Set(['ar']);

export const LOCALE_NAMES: Record<Locale, string> = {
  tr: 'Türkçe',
  en: 'English',
  de: 'Deutsch',
  ar: 'العربية',
};

/** Eksik çeviri zinciri: istenen dil → İngilizce → Türkçe. */
export const FALLBACKS: Record<Locale, Locale[]> = {
  tr: ['tr'],
  en: ['en', 'tr'],
  de: ['de', 'en', 'tr'],
  ar: ['ar', 'en', 'tr'],
};

export function isLocale(v: string | undefined | null): v is Locale {
  return !!v && (SUPPORTED_LOCALES as readonly string[]).includes(v);
}

export function isRtl(locale: string): boolean {
  return RTL_LOCALES.has(locale as Locale);
}

/** `a.b.c` anahtarını katalogda arar; ilk parça ad alanı, kalanı tek anahtar (ör. `permissions.org.user.read`) olabilir. */
export function lookupIn(catalog: unknown, reference: unknown, key: string): string | undefined {
  const [ns, ...rest] = key.split('.');
  const restJoined = rest.join('.');
  const refNs = (reference as Record<string, unknown>)[ns ?? ''];
  const parts =
    refNs && typeof refNs === 'object' && restJoined in (refNs as Record<string, unknown>)
      ? [ns!, restJoined]
      : key.split('.');
  let cur: unknown = catalog;
  for (const part of parts) {
    if (cur && typeof cur === 'object' && part in (cur as Record<string, unknown>))
      cur = (cur as Record<string, unknown>)[part];
    else return undefined;
  }
  return typeof cur === 'string' ? cur : undefined;
}

export function fill(v: string, params: Record<string, string | number>): string {
  return v.replace(/\{\{(\w+)\}\}/g, (_, p: string) => String(params[p] ?? `{{${p}}}`));
}
